var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2867 20.8559V8.20237C23.1979 8.20977 23.1092 8.2147 23.0203 8.2147H1.97966C1.89088 8.2147 1.79964 8.20977 1.71332 8.20237V20.8559C1.71332 21.6722 2.3767 22.3356 3.19298 22.3356H21.807C22.6233 22.3356 23.2867 21.6746 23.2867 20.8559ZM17.4421 13.0779C17.4421 13.4872 17.1116 13.8177 16.7022 13.8177H8.29779C7.88842 13.8177 7.55796 13.4872 7.55796 13.0779V11.1149C7.55796 10.7055 7.88842 10.375 8.29779 10.375H16.6998C17.1091 10.375 17.4396 10.7055 17.4396 11.1149V13.0779H17.4421Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5.25536V3.98039C24.5 3.16411 23.8367 2.50073 23.0203 2.50073H1.97966C1.16338 2.50073 0.5 3.16411 0.5 3.98039V5.25536C0.5 5.98039 1.02281 6.58458 1.71332 6.71035C1.79963 6.72515 1.88841 6.73501 1.97966 6.73501H23.0179C23.1092 6.73501 23.198 6.72515 23.2843 6.71035C23.9772 6.58458 24.5 5.98039 24.5 5.25536Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.418213)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.025f5a9ae5b45b166215b70246a9ddf6.svg";
export { ForwardRef as ReactComponent };